document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('[data-main-search-link]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.getElementById('echo-main-search');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => {
        const field = target.querySelector('[data-echo-search-input], input[type="search"]');
        if (field) field.focus({ preventScroll: true });
      }, 350);
    });
  });


  document.querySelectorAll('[data-home-options-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const panelId = button.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;

      const opening = button.getAttribute('aria-expanded') !== 'true';

      // Keep the homepage tidy by closing other open product option panels.
      document.querySelectorAll('[data-home-options-toggle][aria-expanded="true"]').forEach((other) => {
        if (other === button) return;
        other.setAttribute('aria-expanded', 'false');
        const otherPanel = document.getElementById(other.getAttribute('aria-controls'));
        if (otherPanel) otherPanel.hidden = true;
      });

      button.setAttribute('aria-expanded', opening ? 'true' : 'false');
      panel.hidden = !opening;
    });
  });


  // Echo gender badges: convert (female), (male) and (unisex) inside visible text into themed badges.
  const genderRoot = document.querySelector('main') || document.body;
  const genderPattern = /\((female|male|unisex)\)/ig;
  const genderNodes = [];
  const walker = document.createTreeWalker(genderRoot, NodeFilter.SHOW_TEXT);

  while (walker.nextNode()) {
    const node = walker.currentNode;
    const parent = node.parentElement;
    if (!parent || parent.closest('script, style, select, option, textarea, input, [contenteditable="true"]')) continue;
    if (genderPattern.test(node.nodeValue)) genderNodes.push(node);
    genderPattern.lastIndex = 0;
  }

  genderNodes.forEach((node) => {
    const text = node.nodeValue;
    const frag = document.createDocumentFragment();
    let lastIndex = 0;

    text.replace(genderPattern, (match, gender, offset) => {
      if (offset > lastIndex) {
        frag.appendChild(document.createTextNode(text.slice(lastIndex, offset)));
      }

      const badge = document.createElement('span');
      const key = gender.toLowerCase();
      badge.className = `echo-gender-badge echo-gender-badge--${key}`;
      badge.textContent = gender;
      frag.appendChild(badge);

      lastIndex = offset + match.length;
      return match;
    });

    if (lastIndex < text.length) {
      frag.appendChild(document.createTextNode(text.slice(lastIndex)));
    }

    node.parentNode.replaceChild(frag, node);
    genderPattern.lastIndex = 0;
  });


  document.querySelectorAll('[data-scroll]').forEach((el) => {
    el.addEventListener('click', (event) => {
      const target = document.querySelector(el.dataset.scroll);
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const updateDeliveryProgress = async (cartData = null) => {
    try {
      const cart = cartData || await fetch(`${shopRoot}cart.js`, {
        headers: { Accept: 'application/json' }
      }).then((r) => {
        if (!r.ok) throw new Error('Unable to load cart');
        return r.json();
      });

      const progressBar = document.querySelector('[data-delivery-progress]');
      const configuredThreshold = parseInt(progressBar?.dataset.thresholdPence || '', 10);
      const threshold = Number.isFinite(configuredThreshold) && configuredThreshold > 0
        ? configuredThreshold
        : 5000;
      const total = Number(cart.total_price || 0);
      const remaining = Math.max(0, threshold - total);
      const percent = threshold > 0
        ? Math.max(0, Math.min(100, (total / threshold) * 100))
        : 0;

      document.querySelectorAll('[data-delivery-progress]').forEach((bar) => {
        bar.classList.toggle('is-visible', Number(cart.item_count || 0) > 0);
      });

      document.querySelectorAll('[data-delivery-progress-fill]').forEach((fill) => {
        fill.style.width = `${percent}%`;
      });

      document.querySelectorAll('[data-delivery-progress-text]').forEach((text) => {
        if (remaining <= 0) {
          text.textContent = 'Free delivery unlocked ✓';
        } else if (total <= 0) {
          text.textContent = `Spend £${(threshold / 100).toFixed(2)} for free delivery`;
        } else {
          text.textContent = `You're £${(remaining / 100).toFixed(2)} away from free delivery`;
        }
      });
    } catch (_) {
      document.querySelectorAll('[data-delivery-progress]').forEach((bar) => {
        bar.classList.remove('is-visible');
      });
    }
  };

  let toastTimer;

  const showToast = (message, isError = false) => {
    let toast = document.querySelector('[data-cart-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'echo-cart-toast';
      toast.dataset.cartToast = '';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }

    toast.textContent = message;
    toast.classList.toggle('is-error', isError);
    toast.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 2800);
  };

  const updateCartCount = async () => {
    const response = await fetch(`${shopRoot}cart.js`, {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to refresh bag count');
    const cart = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach((count) => {
      count.textContent = cart.item_count;
    });
    updateDeliveryProgress(cart);
    return cart;
  };

  updateDeliveryProgress();



  // Custom Echo fragrance selector.
  // Keeps the real <select> for Shopify form submission, but replaces the
  // Android/iOS native popup with a fully styled Echo modal.
  const initEchoCustomSelects = () => {
    document.querySelectorAll('select.echo-neon-select').forEach((select) => {
      if (select.dataset.echoCustomReady === 'true') return;
      select.dataset.echoCustomReady = 'true';

      // Hide native select visually but keep it in the form.
      select.classList.add('echo-native-select-hidden');

      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'echo-custom-select-trigger';
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-expanded', 'false');

      const triggerText = document.createElement('span');
      triggerText.className = 'echo-custom-select-trigger__text';

      const triggerArrow = document.createElement('span');
      triggerArrow.className = 'echo-custom-select-trigger__arrow';
      triggerArrow.setAttribute('aria-hidden', 'true');
      triggerArrow.textContent = '⌄';

      trigger.append(triggerText, triggerArrow);
      select.insertAdjacentElement('afterend', trigger);

      const updateTrigger = () => {
        const selected = select.options[select.selectedIndex];
        const fallback = select.options[0]?.textContent || 'Choose fragrance';
        triggerText.textContent = selected && selected.value ? selected.textContent : fallback;
        trigger.classList.toggle('has-value', Boolean(selected && selected.value));
      };

      updateTrigger();
      select.addEventListener('change', updateTrigger);

      const openModal = () => {
        const overlay = document.createElement('div');
        overlay.className = 'echo-select-modal';
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-modal', 'true');

        const panel = document.createElement('div');
        panel.className = 'echo-select-modal__panel';

        const head = document.createElement('div');
        head.className = 'echo-select-modal__head';

        const title = document.createElement('div');
        title.className = 'echo-select-modal__title';
        title.textContent = select.options[0]?.textContent || 'Choose fragrance';

        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'echo-select-modal__close';
        close.setAttribute('aria-label', 'Close fragrance selector');
        close.textContent = '×';

        head.append(title, close);

        const searchWrap = document.createElement('div');
        searchWrap.className = 'echo-select-modal__search-wrap';

        const search = document.createElement('input');
        search.type = 'search';
        search.className = 'echo-select-modal__search';
        search.placeholder = 'Search fragrance…';
        search.autocomplete = 'off';
        searchWrap.appendChild(search);

        const list = document.createElement('div');
        list.className = 'echo-select-modal__list';

        const buildRows = (query = '') => {
          const q = query.trim().toLowerCase();
          list.innerHTML = '';

          Array.from(select.options).forEach((option, index) => {
            if (index === 0 || !option.value) return;
            const scentProfile = select.hasAttribute('data-sample-choice')
              ? String(option.dataset.scentProfile || '').trim()
              : '';
            const searchable = `${option.textContent} ${scentProfile}`.toLowerCase();
            if (q && !searchable.includes(q)) return;

            const row = document.createElement('button');
            row.type = 'button';
            row.className = 'echo-select-modal__option';
            row.dataset.value = option.value;
            row.setAttribute('role', 'option');
            row.setAttribute('aria-selected', option.value === select.value ? 'true' : 'false');

            const copy = document.createElement('span');
            copy.className = 'echo-select-modal__option-copy';

            const name = document.createElement('strong');
            name.textContent = option.textContent;
            copy.appendChild(name);

            if (scentProfile) {
              const profile = document.createElement('span');
              profile.className = 'echo-select-modal__scent-profile';
              profile.textContent = scentProfile;
              copy.appendChild(profile);
            }

            const radio = document.createElement('span');
            radio.className = 'echo-select-modal__radio';
            radio.setAttribute('aria-hidden', 'true');

            row.append(copy, radio);

            if (option.value === select.value) row.classList.add('is-selected');

            row.addEventListener('click', () => {
              select.value = option.value;
              select.dispatchEvent(new Event('change', { bubbles: true }));
              closeModal();
            });

            list.appendChild(row);
          });

          if (!list.children.length) {
            const empty = document.createElement('div');
            empty.className = 'echo-select-modal__empty';
            empty.textContent = 'No fragrances found';
            list.appendChild(empty);
          }
        };

        const footer = document.createElement('div');
        footer.className = 'echo-select-modal__footer';
        footer.innerHTML = '<strong>Can’t see your favourite?</strong><span>More fragrances coming soon!</span>';

        panel.append(head, searchWrap, list, footer);
        overlay.appendChild(panel);
        document.body.appendChild(overlay);

        document.body.classList.add('echo-select-open');
        trigger.setAttribute('aria-expanded', 'true');

        const closeModal = () => {
          overlay.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('echo-select-open');
          window.setTimeout(() => overlay.remove(), 160);
          trigger.focus({ preventScroll: true });
        };

        close.addEventListener('click', closeModal);
        overlay.addEventListener('click', (event) => {
          if (event.target === overlay) closeModal();
        });

        const esc = (event) => {
          if (event.key === 'Escape') {
            document.removeEventListener('keydown', esc);
            closeModal();
          }
        };
        document.addEventListener('keydown', esc);

        search.addEventListener('input', () => buildRows(search.value));

        buildRows();
        requestAnimationFrame(() => overlay.classList.add('is-open'));
        setTimeout(() => search.focus({ preventScroll: true }), 120);
      };

      trigger.addEventListener('click', openModal);
    });
  };

  initEchoCustomSelects();


  // HYBRID 30ML: enable Add to bag only after two different fragrances are chosen.
  document.querySelectorAll('.echo-hybrid-form').forEach((form) => {
    const first = form.querySelector('[data-hybrid-one]');
    const second = form.querySelector('[data-hybrid-two]');
    const addButton = form.querySelector('[data-add-to-bag]');
    const error = form.querySelector('[data-hybrid-error]');
    if (!first || !second || !addButton) return;

    const validateHybrid = () => {
      const hasBoth = Boolean(first.value && second.value);
      const same = hasBoth && first.value === second.value;
      const complete = hasBoth && !same;
      addButton.disabled = !complete;
      form.classList.toggle('is-complete', complete);
      if (error) error.hidden = !same;
    };

    first.addEventListener('change', validateHybrid);
    second.addEventListener('change', validateHybrid);
    validateHybrid();
  });


  // 5 Sample Builder: require all five choices before add-to-bag.
  document.querySelectorAll('.echo-sample-builder-form').forEach((form) => {
    const selects = Array.from(form.querySelectorAll('[data-sample-choice]'));
    const button = form.querySelector('[data-add-to-bag]');
    const progress = form.querySelector('[data-sample-progress]');
    const error = form.querySelector('[data-sample-error]');
    if (!selects.length || !button) return;

    const validateSamples = () => {
      const selected = selects.filter((select) => Boolean(select.value)).length;
      const complete = selected === selects.length;
      if (progress) progress.textContent = `${selected} of ${selects.length} selected`;
      button.disabled = !complete;
      form.classList.toggle('is-complete', complete);
      if (error) error.hidden = complete || selected === 0;
    };

    selects.forEach((select) => select.addEventListener('change', validateSamples));
    validateSamples();
  });


  // 3 fragrance bundle builder: each completed choice goes green; add-to-bag unlocks at 3/3.
  document.querySelectorAll('.echo-bundle-builder-form').forEach((form) => {
    const selects = Array.from(form.querySelectorAll('[data-bundle-choice]'));
    const button = form.querySelector('[data-add-to-bag]');
    const progress = form.querySelector('[data-bundle-progress]');
    const error = form.querySelector('[data-bundle-error]');
    if (selects.length !== 3 || !button) return;

    const validateBundle = () => {
      const selected = selects.filter((select) => Boolean(select.value)).length;
      const complete = selected === 3;
      if (progress) progress.textContent = `${selected} of 3 selected`;
      button.disabled = !complete;
      form.classList.toggle('is-complete', complete);
      if (error) error.hidden = complete || selected === 0;
      selects.forEach((select) => {
        select.classList.toggle('has-bundle-value', Boolean(select.value));
        const trigger = select.nextElementSibling;
        if (trigger && trigger.classList.contains('echo-custom-select-trigger')) {
          trigger.classList.toggle('has-bundle-value', Boolean(select.value));
        }
      });
    };
    selects.forEach((select) => select.addEventListener('change', validateBundle));
    validateBundle();
  });


  // Echo selector state sync: Samples, Hybrid and Bundles.
  // Keeps the visible custom trigger in sync with the hidden native select,
  // including after modal selections and any later DOM updates.
  const syncEchoBuilderStates = () => {
    document.querySelectorAll('.echo-sample-builder-form').forEach((form) => {
      const selects = Array.from(form.querySelectorAll('[data-sample-choice]'));
      const button = form.querySelector('[data-add-to-bag]');
      const progress = form.querySelector('[data-sample-progress]');
      if (!selects.length || !button) return;
      const selected = selects.filter((s) => Boolean(s.value)).length;
      const complete = selected === selects.length;
      form.classList.toggle('is-complete', complete);
      button.disabled = !complete;
      if (progress) progress.textContent = `${selected} of ${selects.length} selected`;
      selects.forEach((select) => {
        const hasValue = Boolean(select.value);
        select.classList.toggle('has-builder-value', hasValue);
        const trigger = select.nextElementSibling;
        if (trigger && trigger.classList.contains('echo-custom-select-trigger')) {
          trigger.classList.toggle('has-builder-value', hasValue);
        }
      });
    });

    document.querySelectorAll('.echo-hybrid-form').forEach((form) => {
      const first = form.querySelector('[data-hybrid-one]');
      const second = form.querySelector('[data-hybrid-two]');
      const button = form.querySelector('[data-add-to-bag]');
      const error = form.querySelector('[data-hybrid-error]');
      if (!first || !second || !button) return;
      [first, second].forEach((select) => {
        const hasValue = Boolean(select.value);
        select.classList.toggle('has-builder-value', hasValue);
        const trigger = select.nextElementSibling;
        if (trigger && trigger.classList.contains('echo-custom-select-trigger')) {
          trigger.classList.toggle('has-builder-value', hasValue);
        }
      });
      const hasBoth = Boolean(first.value && second.value);
      const same = hasBoth && first.value === second.value;
      const complete = hasBoth && !same;
      form.classList.toggle('is-complete', complete);
      button.disabled = !complete;
      if (error) error.hidden = !same;
    });

    document.querySelectorAll('.echo-bundle-builder-form').forEach((form) => {
      const selects = Array.from(form.querySelectorAll('[data-bundle-choice]'));
      const button = form.querySelector('[data-add-to-bag]');
      const progress = form.querySelector('[data-bundle-progress]');
      if (selects.length !== 3 || !button) return;
      const selected = selects.filter((s) => Boolean(s.value)).length;
      const complete = selected === 3;
      form.classList.toggle('is-complete', complete);
      button.disabled = !complete;
      if (progress) progress.textContent = `${selected} of 3 selected`;
      selects.forEach((select) => {
        const hasValue = Boolean(select.value);
        select.classList.toggle('has-builder-value', hasValue);
        const trigger = select.nextElementSibling;
        if (trigger && trigger.classList.contains('echo-custom-select-trigger')) {
          trigger.classList.toggle('has-builder-value', hasValue);
        }
      });
    });
  };

  document.addEventListener('change', (event) => {
    if (event.target && event.target.matches('[data-sample-choice], [data-hybrid-one], [data-hybrid-two], [data-bundle-choice]')) {
      syncEchoBuilderStates();
    }
  });
  syncEchoBuilderStates();
  window.setTimeout(syncEchoBuilderStates, 250);

  document.querySelectorAll('[data-ajax-product-form]').forEach((form) => {
    const price = form.closest('.main-product')?.querySelector('[data-product-price]') || form.closest('.echo-home-product-card')?.querySelector('[data-home-product-price]');
    form.querySelectorAll('.echo-variant-pill-input').forEach((input) => {
      input.addEventListener('change', () => {
        if (input.checked && price && input.dataset.variantPrice) {
          price.textContent = input.dataset.variantPrice;
        }
      });
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const button = form.querySelector('[data-add-to-bag]');
      const status = form.querySelector('[data-product-form-status]');
      if (!button || button.disabled) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.classList.add('is-loading');
      button.textContent = 'Adding…';
      if (status) status.textContent = 'Adding item to bag.';

      try {
        const response = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });

        const result = await response.json();
        if (!response.ok) {
          throw new Error(result.description || result.message || 'This item could not be added.');
        }

        await updateCartCount();
        button.textContent = 'Added to bag ✓';
        if (status) status.textContent = 'Item added to bag. You are still on the product page.';
        showToast('Added to bag');

        window.setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
          button.classList.remove('is-loading');
        }, 1400);
      } catch (error) {
        button.textContent = originalText;
        button.disabled = false;
        button.classList.remove('is-loading');
        const message = error instanceof Error ? error.message : 'This item could not be added.';
        if (status) status.textContent = message;
        showToast(message, true);
      }
    });
  });

  // Private friends / family / work collection access.
  // Matching Shopify free-shipping discount codes for Echo VIP collection access.
  const collectionWrap = document.querySelector('[data-private-collection]');
  if (collectionWrap) {
    const codeInput = collectionWrap.querySelector('[data-collection-code]');
    const unlockButton = collectionWrap.querySelector('[data-collection-unlock]');
    const status = collectionWrap.querySelector('[data-collection-status]');
    const notesWrap = collectionWrap.querySelector('[data-collection-notes]');
    const noteInput = collectionWrap.querySelector('[data-collection-note]');
    const checkoutButton = document.querySelector('.echo-cart__form button[name="checkout"]');
    const normaliseAccessCode = (value) => String(value || '')
      .trim()
      .toUpperCase()
      .replace(/\s+/g, '');

    // First value is what users may type; second value is the exact Shopify discount code.
    const ACCESS_CODES = new Map([
      ['ECHOWORK', 'ECHOWORK'],
      ['ECHOFAMILY', 'ECHOFAMILY'],
      ['ECHOFRIENDS', 'ECHOFRIENDS'],
      ['ECHODANIELLE', 'ECHODANIELLE']
    ]);
    let collectionUnlocked = false;
    let activeAccessCode = '';

    const setStatus = (message, ok = false) => {
      if (!status) return;
      status.textContent = message;
      status.classList.toggle('is-ok', ok);
      status.classList.toggle('is-error', !ok && Boolean(message));
    };

    const unlockCollection = () => {
      const entered = normaliseAccessCode(codeInput?.value);
      if (!ACCESS_CODES.has(entered)) {
        collectionUnlocked = false;
        activeAccessCode = '';
        if (notesWrap) notesWrap.hidden = true;
        setStatus('Code not recognised.');
        return;
      }
      collectionUnlocked = true;
      activeAccessCode = ACCESS_CODES.get(entered);
      if (notesWrap) notesWrap.hidden = false;
      setStatus('Collection access unlocked.', true);
      noteInput?.focus();
    };

    unlockButton?.addEventListener('click', unlockCollection);
    codeInput?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        unlockCollection();
      }
    });

    checkoutButton?.addEventListener('click', async (event) => {
      if (!collectionUnlocked) return;
      event.preventDefault();
      checkoutButton.disabled = true;
      const oldText = checkoutButton.textContent;
      checkoutButton.textContent = 'Preparing checkout…';
      try {
        const response = await fetch(`${shopRoot}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            attributes: {
              'Friends / Family / Work': 'Collection',
              'Collection / order notes': String(noteInput?.value || '').trim()
            }
          })
        });
        if (!response.ok) throw new Error('Could not save collection details');
        const root = shopRoot.endsWith('/') ? shopRoot : `${shopRoot}/`;
        window.location.assign(`${root}discount/${encodeURIComponent(activeAccessCode)}?redirect=/checkout`);
      } catch (error) {
        checkoutButton.disabled = false;
        checkoutButton.textContent = oldText;
        setStatus('Could not save collection details. Please try again.');
      }
    });
  }

  const emptyForm = document.querySelector('[data-empty-cart-form]');
  const emptyButton = document.querySelector('[data-empty-cart]');
  const emptyModal = document.querySelector('[data-empty-cart-modal]');
  const emptyConfirm = document.querySelector('[data-empty-cart-confirm]');
  const emptyCancels = document.querySelectorAll('[data-empty-cart-cancel]');

  const closeEmptyModal = () => {
    if (!emptyModal) return;
    emptyModal.classList.remove('is-open');
    window.setTimeout(() => {
      emptyModal.hidden = true;
      document.body.classList.remove('echo-modal-open');
    }, 180);
  };

  const openEmptyModal = () => {
    if (!emptyModal) return;
    emptyModal.hidden = false;
    document.body.classList.add('echo-modal-open');
    window.requestAnimationFrame(() => {
      emptyModal.classList.add('is-open');
      emptyConfirm?.focus();
    });
  };

  if (emptyForm && emptyButton) {
    emptyForm.addEventListener('submit', (event) => {
      event.preventDefault();
      openEmptyModal();
    });
  }

  emptyCancels.forEach((button) => {
    button.addEventListener('click', closeEmptyModal);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && emptyModal && !emptyModal.hidden) {
      closeEmptyModal();
    }
  });

  if (emptyConfirm && emptyButton) {
    emptyConfirm.addEventListener('click', async () => {
      emptyConfirm.disabled = true;
      emptyConfirm.textContent = 'Emptying…';
      emptyButton.disabled = true;

      try {
        const response = await fetch(`${shopRoot}cart/clear.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('Unable to clear cart');
        window.location.assign(`${shopRoot}cart`);
      } catch (error) {
        emptyConfirm.disabled = false;
        emptyConfirm.textContent = 'Empty bag';
        emptyButton.disabled = false;
        closeEmptyModal();
        showToast('Could not empty bag. Please try again.', true);
      }
    });
  }
});


/* Mobile bottom-nav search: keep homepage search visible above soft keyboard */
(() => {
  function getMainSearchInput() {
    return document.querySelector(
      '#EchoSearchInput, [data-echo-search-input], .echo-search input[type="search"], .echo-search input[type="text"]'
    );
  }

  function positionSearch(input) {
    const section = input.closest('section, .shopify-section, .echo-search, [data-echo-search]') || input;
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });

    window.setTimeout(() => {
      const rect = input.getBoundingClientRect();
      const desiredTop = 110;
      window.scrollBy({ top: rect.top - desiredTop, behavior: 'smooth' });
    }, 280);
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.echo-mobile-nav a, .echo-mobile-nav button');
    if (!link) return;

    const label = (link.textContent || '').trim().toLowerCase();
    const href = link.getAttribute('href') || '';
    const isSearch = label.includes('search') || href.includes('#echo-search') || link.matches('[data-mobile-search]');
    if (!isSearch) return;

    const onHome = location.pathname === '/' || location.pathname === '';
    if (!onHome) return;

    const input = getMainSearchInput();
    if (!input) return;

    event.preventDefault();
    positionSearch(input);

    /* Focus only after scrolling, so Android does not cover the field first. */
    window.setTimeout(() => {
      input.focus({ preventScroll: true });
      input.setSelectionRange?.(input.value.length, input.value.length);

      window.setTimeout(() => positionSearch(input), 180);
    }, 430);
  }, true);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', () => {
      const input = getMainSearchInput();
      if (input && document.activeElement === input) {
        window.setTimeout(() => {
          const rect = input.getBoundingClientRect();
          const vv = window.visualViewport;
          const bottomLimit = vv.height - 24;
          if (rect.bottom > bottomLimit || rect.top < 80) {
            window.scrollBy({
              top: rect.top - 105,
              behavior: 'smooth'
            });
          }
        }, 80);
      }
    });
  }
})();
